import React from 'react'

const DesktopWork = () => {
  return (
    <div>
        <div className='flex p-6 items-center font-display font-bold text-navy'>
      <div className='flex items-center p-4 w-full justify-around'>
        <div>
         <div className='text-7xl whitespace-nowrap pr-8 text-center'>#7</div>
         <div className='text-3xl text-center mt-5'>Ranked Glazier in the <br />Nation by Engineering News-Record</div>
        </div>
        <img src={'/various/enrlogo.webp'} 
             className='w-1/7 object-contain'/>
          
          <p className='text-2xl text-center'>
          We are experts in our craft and hold ourselves to the 
          
          <br /> 
          highest standards throughout each project.

          </p>
          
        </div>
        
      </div> 
      <div>

      </div>
      <div className='bg-cover'
      style={{ backgroundImage: `url(${'../images/380stuart.webp'})` }}>
        <img src={'/various/whatwedo-new2.webp'} 
          className=''/>
      </div>
    </div>
  )
}

export default DesktopWork
